<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="标签名称" name="tag_name"></c-form-item>
					<c-form-item type="checkbox" label="列表显示状态" name="disabled_state" :options="disabledState" ></c-form-item>
					<c-form-item type="checkbox" label="详情显示状态" name="detail_disabled_state" :options="disabledState" ></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_product_service_tag_edit" color="sys" @click="add">新增服务标签</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="标签名称"
					name="tag_name"
					width="100"
				></c-table-column>

        <c-table-column
                label="标签颜色"
                name="tag_color"
        ></c-table-column>

        <c-table-column
                label="标签图片"
                width="80"
        >
            <template v-slot="{data}">
                <c-image :src="data.tag_img" size="60" preview></c-image>
            </template>
        </c-table-column>

        <c-table-column
                label="标签等级"
                name="tag_level"
        >
            <template v-slot="{data}">
                <span v-if="data.tag_level == 1">一级</span>
                <span v-else>二级</span>
            </template>
        </c-table-column>
				
				<c-table-column
					label="标签描述"
					name="tag_desc"
					width="300"
				>
				</c-table-column>
				
				<c-table-column
					label="设置商品数量"
					name="product_count"
					width="100"
				></c-table-column>
				
				<c-table-column
					label="列表是否显示"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.disabled_state == 1" style="color:green">显示</span>
						<span v-else style="color:gray">隐藏</span>
					</template>
				</c-table-column>

        <c-table-column
                label="详情是否显示"
                width="100"
        >
            <template v-slot="{data}">
                <span v-if="data.detail_disabled_state == 1" style="color:green">显示</span>
                <span v-else style="color:gray">隐藏</span>
            </template>
        </c-table-column>
				
				<c-table-column
					type="sort"
					label="排序"
					power="b_product_param_sort"
					@sort="sortHandle"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="180"
				>
					<template v-slot="{data}">
						<c-table-button power="b_product_service_tag_edit" v-if="data.disabled_state == 2" @click="disabledHandle(data, false,1)">列表显示</c-table-button>
						<c-table-button power="b_product_service_tag_edit" v-else @click="disabledHandle(data, true,1)">列表隐藏</c-table-button>
                        <c-table-button power="b_product_service_tag_edit" v-if="data.detail_disabled_state == 2" @click="disabledHandle(data, false,2)">详情显示</c-table-button>
<!--
                        <c-table-button power="b_product_service_tag_edit" v-else @click="disabledHandle(data, true,2)">详情隐藏</c-table-button>
-->
						<c-table-button power="b_product_service_tag_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_product_service_tag_edit" @click="del(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="editDialog" :title="editState ? '编辑服务标签' : '新增服务标签'" width="600" @resolve="submit">
			<c-form ref="editForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="input" label="标签名称" name="tag_name" required maxlength="4"></c-form-item>
        <c-form-item type="color" label="标签颜色" name="tag_color" word="不配置则使用默认色"></c-form-item>
        <c-form-item type="image" label="标签图片" name="tag_img" file-word="传标签图片则优先显示，不传则显示文字标签。图片建议尺寸：高度60px，最大宽度不超过160px"></c-form-item>
        <c-form-item type="radio" label="标签等级" name="tag_level" :options="levels" word="等级越高，排序越靠前" value="1"></c-form-item>
				<c-form-item type="input" label="标签描述" name="tag_desc"></c-form-item>
        <c-form-item type="textarea" label="使用场景说明" name="use_scene_desc"></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_product_service_tag',
		
		data() {
			return {
				editState: false,
				disabledState: [{
						name: '显示',
						value: 1
					},{
						name: '隐藏',
						value: 2
					}
				],
                levels: [{
                    name: '一级',
                    value: 1
                },{
                    name: '二级',
                    value: 2
                }
                ],
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/product/service/tag/list',
					data
				});
			},

			disabledHandle(data, disabled,opearFlag) {
			    //列表显示状态
			    if(opearFlag == 1){
                    this.request({
                        url: '/product/service/tag/state',
                        data: {
                            id: data.id,
                            disabled_state: disabled ? 2 : 1
                        },
                        loading: true,
                        success: () => {
                            data.disabled_state = disabled ? 2 : 1;
                        }
                    });

                }else{
			        //详情显示状态
                    this.request({
                        url: '/product/service/tag/detail_state',
                        data: {
                            id: data.id,
                            detail_disabled_state: disabled ? 2 : 1
                        },
                        loading: true,
                        success: () => {
                            data.detail_disabled_state = disabled ? 2 : 1;
                        }
                    });
                }

			},
			
			add() {
				this.editState = false;
				this.$refs.editForm.clear();
				this.$refs.editForm.set({tag_name:'',tag_desc:'',tag_level:2});
				this.$refs.editDialog.open();
			},
			
			edit(val) {
                this.$refs.editForm.clear();
				this.editState = true;
				this.$refs.editForm.set(val);
				this.$refs.editDialog.open();
			},

			del(val) {
				this.$confirm({
					text: (val.product_count ? '当前标签已配置商品，将同时删除关联信息，' : '') + '确定要删除【'+val.tag_name+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product/service/tag/delete',
							data: {tag_id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			sortHandle(row, type, next) {
				//row.prev() 上一行数据
				//row.next() 下一行数据
				let submitData ={};
				submitData.sort_type = type;
				if(type=='top' || type=='bottom'){
					submitData.id = row.data.id;
				}
				if(type=='up'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.prev().data.id;
				}
				if(type=='down'){
					submitData.id1 = row.data.id;
					submitData.id2 = row.next().data.id;
				}
				this.request({
					url: '/product/service/tag/sort',
					data: submitData,
					loading: true,
					success: data => {
						next();
					}
				});
			},
			
			submit(stop) {
				stop();
				this.$refs.editForm.submit({
					url: this.editState ? '/product/service/tag/update' : '/product/service/tag/add',
					rule: {
						tag_name: '请填写标签名称'
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.table.update();
						this.$refs.editDialog.close();
					}
				});
			}
		}
	}
</script>